"use client";
import { Wishlist } from "@/features/wishlist/Wishlist";
import { useSearchParams } from "next/navigation";
import AccountInfo from "./AccountInfo/AccountInfo";
import OrdersAccordions from "./Orders/Accordions/OrdersListAccordions";
import Overview from "./Overview";
import { ACCOUNT_TABS } from "./consts";

export const AccountTabs = () => {
  const searchParams = useSearchParams();

  const activeTab = searchParams.get("tab");

  switch (activeTab) {
    case ACCOUNT_TABS.overview:
      return <Overview />;
    case ACCOUNT_TABS.orderHistory:
      return <OrdersAccordions />;
    case ACCOUNT_TABS.favourites:
      return <Wishlist />;
    case ACCOUNT_TABS.accountSettings:
      return <AccountInfo />;
    default:
      return <Overview />;
  }
};
